import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { PIPELINE } from "@/lib/data";
import { SectionHead, SHELL } from "@/components/bits";

export default function PipelineSection() {
    const [open, setOpen] = useState(0);
    return (
        <section className="relative py-24 md:py-32 bg-vera-bg2/30 border-y border-white/10" data-testid="solution-pipeline">
            <SHELL>
                <SectionHead
                    index="03"
                    label="THE VERA SOLUTION"
                    title={"FROM REAL ASSETS TO\nPROGRAMMABLE CAPITAL."}
                    sub="Seven stages turn real-world value into capital that can move. Select a stage to see what happens inside it."
                />
                <div className="relative">
                    <div className="absolute left-[7px] md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-vera-blue/50 via-white/10 to-vera-gold/50" aria-hidden="true" />
                    <div className="space-y-4">
                        {PIPELINE.map((s, i) => {
                            const isOpen = open === i;
                            const left = i % 2 === 0;
                            return (
                                <div key={s.num} className={`relative md:w-1/2 pl-9 ${left ? "md:pr-14" : "md:ml-auto md:pl-14"} md:pl-0`}>
                                    <div
                                        className={`absolute top-7 left-0 md:left-auto w-3.5 h-3.5 rotate-45 border transition-colors ${left ? "md:-right-[7px]" : "md:-left-[7px]"} ${isOpen ? "border-vera-gold bg-vera-gold/30" : "border-vera-blue bg-vera-bg"}`}
                                        aria-hidden="true"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        aria-expanded={isOpen}
                                        data-testid={`pipeline-stage-${i + 1}`}
                                        className={`w-full text-left glass-card px-6 py-5 transition-all ${isOpen ? "border-vera-gold/50" : "hover:border-vera-blue/40"}`}
                                    >
                                        <div className="flex items-center justify-between gap-4">
                                            <div className="flex items-center gap-4">
                                                <span className="font-mono text-[10px] text-vera-gold">{s.num}</span>
                                                <span className="font-bold tracking-wide text-sm sm:text-base">{s.title}</span>
                                            </div>
                                            <Plus className={`w-4 h-4 text-vera-mut transition-transform duration-300 shrink-0 ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" />
                                        </div>
                                        {isOpen && (
                                            <motion.p
                                                initial={{ opacity: 0, y: -6 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.35 }}
                                                className="text-sm text-vera-mut leading-relaxed mt-4 pt-4 border-t border-white/10"
                                            >
                                                {s.text}
                                            </motion.p>
                                        )}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </SHELL>
        </section>
    );
}
